<h2 mat-dialog-title>Leave a Review</h2>
<mat-dialog-content class="mat-typography">
  <div class="main">
    <div class="rate">
      <input type="radio" id="star5" name="rate" value="5" [(ngModel)]="radioSelected" />
      <label for="star5" title="text">5 stars</label>
      <input type="radio" id="star4" name="rate" value="4" [(ngModel)]="radioSelected" />
      <label for="star4" title="text">4 stars</label>
      <input type="radio" id="star3" name="rate" value="3" [(ngModel)]="radioSelected" />
      <label for="star3" title="text">3 stars</label>
      <input type="radio" id="star2" name="rate" value="2" [(ngModel)]="radioSelected" />
      <label for="star2" title="text">2 stars</label>
      <input type="radio" id="star1" name="rate" value="1" [(ngModel)]="radioSelected" />
      <label for="star1" title="text">1 star</label>
    </div>
    <div>
      <p>Leave a Comment:</p><input name="comment" [(ngModel)]="comment">
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="sendReview()">Save Review</button>
</mat-dialog-actions>